<template>
  <el-container class="patient-page"
                v-loading="relationShipListLoading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.5)">
    <el-header>
      <!-- <Header ref="header"></Header> -->
    </el-header>
    <el-main>
      <div class="patient-page-container">
        <!--左侧信息展示-->
        <div class="patient-page-left">
          <div class="tool-bar">
            <span @click="$router.go(-1)" class="back-button"><i class="el-icon-arrow-left"></i><i>返回</i></span>
            <div>
            </div>
          </div>
          <UserCard ref="userCard" v-if="patientData.patientId && showComponent"
                    :patientData="patientData" @getPatientTags="getPatientTags"></UserCard>
          <div style="width: 400px;margin-top: 10px;">
            <el-tabs v-model="activeName" type="border-card">
              <el-tab-pane name="1" label="参考信息">
                <referenceInformation ref="referenceInfo" v-if="patientData.patientId&& showComponent"
                                      :patientData="patientData"></referenceInformation>
              </el-tab-pane>
              <el-tab-pane name="2" label="历史随访">
                <followupHistoryList ref="followHistory" v-if="patientData.patientId&& showComponent"
                                     :patientData="patientData"></followupHistoryList>
              </el-tab-pane>
              <el-tab-pane name="3" label="医院信息">
                <PatientInHospital :patientData="patientData" ref="patientRecord"></PatientInHospital>
              </el-tab-pane>
              <el-tab-pane name="4" label="质控">
                <div v-if="checklist.length">
                  <div class="checklist-container" style="margin-bottom: 15px;" v-for="(item,index) in checklist"
                       :key="index">
                    <!-- <div style="font-weight: 700;margin-bottom: 6px;display: inline-block" >抽查时间：{{item.createTime}}</div>
                    <div style="margin-bottom: 8px;line-height: 24px;" v-html="item.sbResult"></div> -->
                    <div class="checklist-item-header">
                      <span style="font-weight: bold;">{{
                          item.secondSpotCheckState == "0" ? '不合格' : '合格'
                        }} | {{ item.handleResultName }}</span>
                      <span class="item-header-date">{{ item.createTime }}</span>
                    </div>
                    详情描述：
                    <div class="checklist-item-detail">
                      <div style="border-bottom:1px solid #ccc;">{{ item.firstSpotCheckStateStr }}</div>
                      <div class="remarks-detail" v-html="item.spotCheckRemarks" style="padding:5px"></div>
                    </div>
                    <!-- 图片展示 -->
                    <div v-if="picLoading" class="picture-show">
                      <viewer :images="item.imageUrlAfter" class="image-view">
                        <img v-for="(item,index) in item.imageUrlAfter" :key="index" :src="item" alt>
                      </viewer>
                    </div>
                    <div><span
                        style="font-weight:bold;">质控得分：{{ item.qualityScore ? item.qualityScore : '无' }}</span>
                    </div>

                    <div v-if="item.manageCheckRemarks">
                      <div class="checklist-item-header"><span style="font-weight: bold;">追加质控：</span><span
                          class="item-header-date">{{ item.replyTime }}</span></div>
                      <!--                      {{ item.manageCheckRemarks }}-->
                      <div v-for="(it,ind) in item.manageHistoryCheckRemark" :key="ind">
                        <span>{{ it.value }} </span>
                        <span>{{ it.key }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <template v-else>
                  <span class="no-data">
                      <p>暂无质控记录</p>
                      <img src="../referenceInformation/img/no-result.png" alt="暂无数据"/>
                  </span>
                </template>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
        <!--问卷部分-->
        <div class="patient-page-right " :class="{'stretchall':stretchall}">
          <div class="qs-header">
            <span class="qs-header-label">问卷信息</span>
            <div>
<!--              <el-button @click="saveCurrentPage" type="primary" size="mini">保存当前页</el-button>-->
              <span v-if="patientData.lastFollowupTime">上次随访时间：</span>
              {{ patientData.lastFollowupTime }}
              <!--<el-switch-->
              <!--v-model="qsSwich"-->
              <!--active-color="#248cfa"-->
              <!--inactive-color="#606266"-->
              <!--active-text="全部展示">-->
              <!--</el-switch>-->
            </div>
            <!--<el-button type="text" icon="el-icon-s-unfold" class="stretch" @click="stretchall=true"-->
            <!--v-if="!stretchall"></el-button>-->
            <!--<el-button type="text" icon="el-icon-s-fold" class="stretch" @click="stretchall=false"-->
            <!--v-if="stretchall"></el-button>-->
          </div>
          <div class="qs-content">
            <question-tree-node  :infoId="patientData.followUpPatientInfoId" :questionDisabled="true"
                                v-if="patientData.followupPatientId && qsLoaded && !patientData.isNewTask"
                                :patientId="followupPatientId_p" :taskId="getTaskCenterId"
                                ref="questionTreeNode" :isRecord="isRecord"></question-tree-node>
          </div>
        </div>
        <!--中间信息展示-->
        <div class="patient-page-center" v-show="!stretchall">
          <!--          <div class="patient-page-center-mask">-->

          <!--          </div>-->
          <div>
            <UserPhone refs="userphone" @afterStatus="userPhoneAfterStatus"
                     @refreshConcatInfo="asyncGetPatientContacks"
                     :patientData="patientData" ref="userphone"
                     @getPatientData="getPatientData"
                     @saveRemark="saveRemark" @getOverFollowUp="getOverFollowUp"
                     @manualCall="manualCall" :isAbnormal="isAbnormal"></UserPhone>
          </div>
          <div class="remark-panel">
            <RemarkInfo ref="remarkInfo" :taskId="getTaskCenterId" :patientData="patientData" :key="timer" :patientTags="patientTags" @refreshTags="refreshTags"></RemarkInfo>
          </div>
        </div>
      </div>

    </el-main>
    <el-footer>
      <Footer></Footer>
    </el-footer>
  </el-container>
</template>
<script type="text/ecmascript-6">
//====================新问卷v3===================
import questionNew from '../question_Third/question'

import referenceInformation from '../referenceInformation/referenceInformation'
import followupHistoryList from '../referenceInformation/followupHistoryList'
// 患病者-- 资料页
import UserCard from '../patient/UserCard.vue'
import UserPhone from '../patient/UserPhoneWrongDetail.vue'
// import UserRemark from '../patient/UserRemark.vue'
import RemarkInfo from '../patient/RemarkInfoWrongDetail.vue'
import Header from '../common/Header'
import Footer from '../common/Footer'
import PatientInHospital from '../patient/patientInHospital/patientInHospitalIndex' //患者报告列表
import lastFollowResult from '../followInfo/lastFollowResult'  // 上次随访结果
import _ from 'lodash'
import questionTreeNode from '../questionPreview/question-root-node-new'
import {
  RestFeedbackOutControllerIsRemind,
  RestNewFollowupCallCenterServiceGetFollowUpPatientCondition,
  RestNewFollowupCallCenterServiceGetTodayFollowupCount,
  RestFeedbackOutControllerUpdateRecordList,
  RestFeedbackOutControllerGetRecordList,
  RestNewFollowupCallCenterServiceGetFollowupTaskPatientInfo,// 获取随访任务患者信息
  RestNewFollowupCallCenterServiceGetAbnormalFollowupTaskPatientInfo,//获取随访任务异常患者信息
  RestNewFollowupCallCenterServiceGetIncompleteFollowupTaskPatientInfo,//获取随访任务未完成随访任务的患者信息
  RestNewFollowupCallCenterServiceGetCallLaterFollowupTaskPatientInfo,//稍后拨打
  RestNewFollowupCallCenterServiceGetFollowupPatientContactInformationList,// 获取患者的联系方式
  RestNewFollowupCallCenterServiceGetFollowupPatientRemarks,// 获取随访患者的备注
  RestNewFollowupCallCenterServiceUpdateFollowupPatientRemarks,// 更新随访患者的备注信息
  RestNewFollowupCallCenterServiceUpdateFollowupPatient,// 更新随访患者信息
  RestNewFollowupCallCenterServiceUpdateFollowupTaskAbnormalCall,// 设置患者为异常呼叫
  RestNewFollowupCallCenterServiceGetFollowupTaskReplayPatientInfo,
  RestNewFollowupCallCenterServiceGetFollowUpTodayCompletePatientInfo,
  RestReferenceControllerGetFollowupSpotCheckRemarksList,  //历史抽查记录
  RestNewFollowupCallCenterServiceGetCallLaterFollowupTaskPatientInfoList, //获取抽查列表
  RestNewFollowupCallCenterServiceGetAbnormalFollowupTaskPatientInfoList,
  RestFeedbackOutControllerAddFollowupQualityTime, //质控开始时间
  RestFeedbackOutControllerUpdateFollowupQualityTime, //质控结束时间
  RestNewFollowupCallCenterServiceUpdateAbnormalCallOrCallLater, //更新随访任务异常呼叫或稍后拨打
  RestNewFollowupCallCenterServiceUpdateFollowUpPatientInfoByParams, //是否复核
  RestNewFollowupCallCenterServiceGetSeatsFollowupTaskStatisticsInfo
} from "@src/assets/js/api.js";
import {mapGetters, mapMutations, mapState} from 'vuex';
import errorHandleMixin from "@mixins/errorHandleMixin";
import TimePicker from 'components/timePicker/indexNew.vue'

export default {
  name: 'callPatientMain',
  data() {
    var validateDeathTime = (rule, value, callback) => {
      console.log("fdsfasdfs", value);
      if (value && value.yearSelect) {
        callback();
      } else {
        callback("请选择患者死亡时间");
      }
    };
    return {
      incapReason: "",
      incapDialogVisible: false,
      activeName: "4",
      isRemind: false,
      // taskId: null,
      showMask: false,
      phoneCallStateList: [
        {code: 1, codeName: '稍后拨打'},
        {code: 2, codeName: '仅随访该号码'},
        {code: 3, codeName: '短信随访成功'},
        {code: 4, codeName: '电话随访成功'},
        {code: 5, codeName: '初始化'},
        {code: 6, codeName: '挂断（接通）'},
        {code: 7, codeName: '无人接听'},
        {code: 8, codeName: '挂断（未接通）'},
        {code: 9, codeName: '停机'},
        {code: 10, codeName: '关机'},
        {code: 11, codeName: '拒随'},
        {code: 12, codeName: '空号'},
        {code: 13, codeName: '错号'},
        {code: 14, codeName: '不知情'},
        {code: 15, codeName: '沟通不畅'}], // 电话状态列表
      finishStatus: '',
      followupTypeSign: 0,
      followupNum: null,
      confirmParams: {},
      multipleSelection: [],
      callRecordList: [],
      callRecordListVisible: false,
      showComponent: true,
      stretchall: false,
      qsSwich: false,// 是否展示全部问卷
      timeToNow: {},
      patientData: {},// 获取患者的信息
      saveRemarkIng: false,
      form: {
        remark: '',
      },
      isCalling: false,
      follow: {
        isDeath: null,
        followStatus: "",
        deathTime: {},
        deathReason: "",
      },
      followRules: {
        deathTime: [
          {required: true, validator: validateDeathTime, trigger: 'blur'}
        ],
        deathReason: [
          {required: true, message: '请填写死亡原因', trigger: 'blur'}
        ],
      },
      relationShipListLoading: false,
      refuseFinsh: false,// 拒绝随访
      successFinsh: false,// 成功随访
      hasFinsh: false,
      abnormalLoading: false,// 点击异常患者loading
      finishConfirm: false,//点击结束随访患者loading
      qsLoaded: true,
      lostStatus: false,// 失访
      checklist: [],
      followupPatientId_p: '',//问卷  用
      followupQualityId: null, //质控时间 用
      abnormalDialogShow: false,
      afterCall: {
        afterCallChecked: false, //是否选择稍后拨打
        afterCallTime: null
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '明天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24);
              picker.$emit('pick', date)
            }
          },
          {
            text: '后天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 2);
              picker.$emit('pick', date)
            }
          },
          {
            text: '一周之后',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date)
            }
          }
        ],
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 3600 * 1000;
        },
      },
      currentPatientId: null,
      isReview: false, //是否复核
      picLoading: false,
      targetData: "0/0",
      autoToNext: false,
      afterCallForm: {
        type: 1,
        afterCallTime: null,
        fileId: null
      },
      filetableData: [],
      timer: null,
      isRecord: false, //是否记录编辑问卷
      patientTags: []
    }
  },//
  computed: {
    ...mapGetters([
      'userid',
      'patientId',
      'taskValue',
      'username',
      'getTaskCenterId',
    ]),
    ...mapState([
      'workBenchCallStatus',
      'taskId',
      'nextCallNumberId',
      'currentCallNumberId',
      'currentCallNumber',
      'follupTime',
      'follupTimeString',
      'contactId',
      'contactSuccessIds',
      'taskType'
    ]),
    canFinnishBtn() { //完成按钮
      if (this.hasFinish) {
        return false;
      } else {
        return true;
      }
    },
    taskType() {
      let taskType = this.$route.query.taskType && parseInt(this.$route.query.taskType, 10) || ''
      return taskType;
    },
    isAbnormal() { // 患者是正常或者异常
      return this.$route.query.abnormal != 3; //!=3是正常 3是异常
    },
  },
  watch: {
  },// 实时监听
  mixins: [errorHandleMixin],
  components: {
    questionNew,
    Header,
    Footer,
    UserCard,
    UserPhone,
    TimePicker,
    PatientInHospital,
    lastFollowResult,
    questionTreeNode,
    referenceInformation,
    followupHistoryList,
    RemarkInfo

  },

  // ==========进入页面时和离开页面时========
  beforeRouteLeave(to, from, next) {
    let vm = this
    if (vm.isCalling) {
      window.workbench && window.workbench.hangUp();
      this.setCurrentCalling(false)
    }
    // this.updateFollowupQualityTimeAsync()
    next();
  },// this.displaySettingItem(function () => { function addItem() => { console.log()}})
  mounted() {
    let vm = this

    this.followupTaskId = this.getTaskCenterId
    // 因为可能修改 bug  ，热更新 没有获取到值
    this.getPatientData();
    this.getPatientRecord();
    this.getReferenceInfo();
    this.getFollowHistory();
    this.getUserCard();
    this.getTodayFollowupNum()
  },
  methods: {
    ...mapMutations([
      "setCurrentPage",
      "setcurrentPatient",
      "setCurrentTaskId",
      "setTaskType",
      "resetPatient",
      'removeContactId',
      'removeContactIds',
      "setCurrentCalling",
      "resetCallBackPatient"
    ]),
    updateSuspectedIncapableState() {
      if(!this.incapReason) {
        this.$message.error('加入黑名单原因不可为空')
        return false
      }
      this.updateIncapStatus(this.incapReason)
      // this.$prompt('加入黑名单原因', '加入黑名单', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   inputPlaceholder: '请输入将该患者加入黑名单原因',
      //   inputType: 'textarea',
      //   inputPattern: /^[a-zA-Z0-9\s]{1,500}$/,
      //   inputErrorMessage: '加入黑名单原因不可为空'
      // }).then(({ value }) => {
      //   this.updateIncapStatus(value)
      // }).catch(() => {
      // });
    },
    updateIncapStatus(value = "") {
      this.$store.dispatch('requestHandler', {
        fn: 'RestNewFollowupCallCenterServiceUpdateSuspectedIncapableState',
        params: {
          incapableReason: value || null,
          confirmName: this.username,
          confirmId: this.userid,
          followupPatientId: this.patientData.followupPatientId,
          followUpTaskId: this.getTaskCenterId,
        } 
      }).then(res => {
        if(res.retValue == 'SUCCESS') {
          this.$message.success('加入黑名单成功')
          this.incapDialogVisible = false
        }else {
          this.$message.error('加入黑名单失败')
        }
      })
      //设备维护
    },
    saveCurrentPage() {
      this.$refs.questionTreeNode.bantchSaveAnswer()
    },
    //去听录音
    rebackVideo() {
      this.callRecordListVisible = false
      this.$refs.userphone.rebackVideoAuto()
      this.finishConfirm = false
      // let isLast =
    },
    getCallState(status) {
      console.log(this.phoneCallStateList.find(item => item.code == status));
      return this.phoneCallStateList.find(item => item.code == status).codeName
    },
    handleSelectionChange(val) {
      this.multipleSelection = val.map(item => {
        return item.id
      });
    },
    // // 添加质控时间--开始
    // addFollowupQualityTime(fpid) {
    //   this.addFollowupQualityTimeAsync(fpid).then(res => {
    //     console.log("质控开始")
    //     this.followupQualityId = res.retValue
    //   });
    // },

    //生存状态切换
    changeIsDeathHandler() {
      this.follow.followStatus = ""
    },
    confirmRecordSelect() {
      this.setCurrentPage(100)
      if (this.multipleSelection.length) {
        this.updateRecordList({ids: this.multipleSelection})
            .then(res => {
              if (res.status == 0) {
                this.$message.success('提交成功')
              }
            })
      }
      this.callRecordListVisible = false
      this.confirmParams.spotCheckId = this.$route.query.spotCheckId

      this.asyncUpdatePatientFollowResult(this.confirmParams).then(res => {
        if (this.$route.query.abnormal == 3) {
          this.updateNextAbnormalPatient();
        } else if (this.$route.query.abnormal == 4) {
          this.updateNextCallLaterPatient();
        }else if(this.$route.query.abnormal == -1) {
          this.updateNextAllAbPatient()
        } else if (this.$route.query.abnormal == 7) { //收藏夹中的患者
          this.goBack();
        }
      })
      if (!this.autoToNext) {
        this.goBoardPage()
      }
      this.follow.isDeath = ""
      this.follow.followStatus = ""
      let questionBaseInfo = JSON.parse(localStorage.getItem('questionBaseInfo')) || []
      if (questionBaseInfo.length) {
        let index = questionBaseInfo.findIndex(item => item.NO === this.admitNo)
        questionBaseInfo.splice(index, 1)
        localStorage.setItem('questionBaseInfo', JSON.stringify(questionBaseInfo))
      }
      this.refreshComponent();
    },
    cancelRecordSelect() {
      this.callRecordListVisible = false
      this.finishConfirm = false
    },
    //获取呼叫记录列表
    async getCallListAsync(p) {
      let request = new RestFeedbackOutControllerGetRecordList()
      request.p_followUpPatientInfoId = p.followUpPatientInfoId
      await request.send()
      return request.result
    },
    //提交呼叫记录RestFeedbackOutControllerUpdateRecordList
    async updateRecordList(p) {
      let request = new RestFeedbackOutControllerUpdateRecordList()
      request.p_ids = p.ids
      await request.send()
      return request.result
    },
    async getTodayFollowupNum() {
      let request = new RestNewFollowupCallCenterServiceGetTodayFollowupCount()
      request.p_seatId = sessionStorage.getItem('userid')
      request.p_taskId = this.getTaskCenterId
      await request.send()
      if (request.result.status == 0) {
        this.followupNum = request.result.retValue
      }
    },
    //=================================userPhone=========================
    /**
     * 处理挂断组件-完成
     */
    getOverFollowUp(finshStatus) {
      console.log('[finshStatus]', finshStatus == 'successFinsh');
      this.finishStatus = finshStatus
      // if (finshStatus) {
      //   this['finshStatus'] = true;
      //   if (finshStatus != 'lostStatus') {
      //     this.lostStatus = false
      //   }
      // } else {
      //   this.lostStatus = false
      // }
      // //异常患者处理失访逻辑
      // if (!this.isAbnormal) {
      //   if (this.refuseFinsh || this.successFinsh) {
      //     this.lostStatus = false
      //   }
      // } else {
      //   // 正常患者
      //   if (finshStatus == 'lostStatus') {
      //     this.refuseFinsh = false
      //     this.successFinsh = false
      //   }
      //
      // }
      this.hasFinsh = true
      this.showMask = false
    },
    /**
     * 完成时候由子组件触发
     */
    getPatientData() {
      let vm = this
      this.initBaseData()
          .then(() => {
            if (this.$refs['userphone']) {
              this.$refs['userphone'].isModel = 'beMessage';
            }
            this.getCurrentPatientInfo()
                .then(() => {
                  // vm.$refs.userRemark.onLoad()
                  this.qsLoaded = true
                })
          })

    },
    manualCall() {
      console.log("header===>refs", this.$refs.header)
      this.$refs.header.setCallingStatus()
    },
    manualCallBack(callNumber) {
      console.log("header===>refs", this.$refs.header, callNumber)
      this.$refs.userphone.manualCallBack(callNumber)
    },
    // 挂断后 ===  userPhone
    userPhoneAfterStatus() {
      this.$refs['userphone'].setCallHangUpStatusDialog();
    },
    //  保存的触发点设置为离开该随访人
    saveRemark() {
      // 重新刷新 患者hh
      this.getPatientData();
    },
    //===============================患者====================================
    initBaseData() {
      return new Promise((resolve => {
        let vm = this;
        this.refuseFinsh = false;
        this.successFinsh = false;
        this.hasFinsh = false;
        this.follow.followStatus = ""
        this.follow.isDeath = ""
        this.follow.deathTime = {}
        this.follow.deathReason = ""
        this.qsLoaded = false
        resolve()
      }))

    },
    getCurrentPatientInfo() {
      return new Promise((async resolve => {
        let vm = this;
        let params = {
          userId: this.userid
        };
        if (typeof params.userId === "undefined") {
          vm.errorHandle({message: "无法获取操作人员的ID,请重新登录"});
          return false;
        }
        this.relationShipListLoading = true;
        this.autoToNext = true
        await this.asyncGetNormalPatientInfo(params).then((data) => {
          if (data.status == 0) {
            vm.patientData = data.retValue || {}
            vm.setcurrentPatient(data.retValue);
            this.followupPatientId_p = data.retValue.followupPatientId; //查询问卷所需的followupPatientId
            vm.setCurrentTaskId(data.retValue.id);
            //获取患者的联系方式
            vm.asyncGetPatientContacks(data.retValue.patientId);
            vm.currentPatientId = data.retValue.patientId
            // 获取患者的备注信息
            vm.asyncGetPatientRemarks(data.retValue.followupPatientId);
            vm.getPatientRecord()
            vm.refreshComponent()
            this.getReferenceInfo();
            this.getFollowHistory();
            this.getUserCard();
            this.getRemarksList(data.retValue.followupPatientId);
            vm.getLastResult()
            // this.addFollowupQualityTime(data.retValue.followupPatientId);
          }
        }).catch(err => {
          vm.errorHandle(err);
          this.relationShipListLoading = false;
        })
        this.timer = new Date().getTime()
        this.relationShipListLoading = false
        resolve()
      }))
    },
    getPatientError() {
      // 获取任务信息失败
      let vm = this;
      vm.$router.go(-1)
    },
    abnormalOrAfter() {
      // 异常/稍后
      // this.getPatientContacksAsync().then(res => {
      //   let temp = res.retValue.find(item => item.lastCallState == 1)
      //   if (temp) {
      //     this.getPatientContacksAsync().then(res => {
      //       let temp = res.retValue.filter(item => {
      //         return item.laterCallTime
      //       })
      //       if (temp.length > 0) {
      //         this.afterCallForm.type = 2//是否选择稍后拨打
      //         this.afterCallForm.afterCallTime = temp[0].laterCallTime
      //       }
      //     })
      //   } else {

      //     this.afterCallForm.type = 1
      //     this.afterCallForm.afterCallTime = null
      //   }
      // })
      this.afterCallForm.type = 1
      this.afterCallForm.afterCallTime = null
      // 收藏夹
      this.getExceptionFile()
    },
    getExceptionFile() {
      this.$store.dispatch('requestHandler',
          {
            fn: 'RestAbnormalFollowupFileControllerGetExceptionFile',
            params: {
              seatId: this.userid,
              taskId: this.getTaskCenterId,
              followupPatientId: this.patientData.followupPatientId
            }
          }
      ).then(res => {
        if (res.status == 0 && res.retValue.length > 0) {
          this.filetableData = res.retValue
          let _filedata = res.retValue.find(item => item.isExit)
          if (_filedata) {
            this.afterCallForm.fileId = _filedata.id
          } else {
            this.afterCallForm.fileId = null
          }
        } else {
          this.filetableData = []
        }
        this.abnormalDialogShow = true;
      })
    },
    afterCallChangeHandle() {
      if (!this.afterCall.afterCallChecked) {
        this.afterCall.afterCallTime = null
      }
    },
    nextTimeValidator(rule, value, callback) {
      if (value) {
        let selectTime = new Date(value).getTime()
        let now = new Date().getTime();
        if (selectTime < now) {
          callback('选择的时间必须为未来时间')
        } else {
          callback()
        }
      } else {
        callback()
      }
    },
    getIsDeath(val) {
      switch (val) {
        case 1:
          return false;
          break
        case 2:
          return true;
          break
        case 3:
          return false;
          break
      }
    },
    refreshComponent() {
      this.showComponent = false
      setTimeout(() => {
        this.getTodayFollowupNum()
        this.showComponent = true
      }, 200)
      this.$forceUpdate()
    },
    /**
     * 获取患者的检查报告
     */
    getPatientRecord() {
      let vm = this;
      if (vm.$refs['patientRecord']) {
        vm.$refs['patientRecord'].getRecrods()
      }
    },
    getReferenceInfo() {
      let vm = this;
      if (vm.$refs['referenceInfo']) {
        vm.$refs['referenceInfo'].getReferenceInfo()
      }
    },
    getFollowHistory() {
      let vm = this;
      if (vm.$refs['followHistory']) {
        vm.$refs['followHistory'].getReferenceInfo()
      }
    },
    getUserCard() {
      let vm = this;
      if (vm.$refs['userCard']) {
        vm.$refs['userCard'].init()
      }
    },
    getRemarksList(id) {
      let vm = this;
      let params = {
        followUpPatientId: vm.$route.query.followupPatientId || id,
        followupTaskId: vm.getTaskCenterId
      }
      vm.getFollowupSpotCheckRemarksListAsync(params).then(res => {
        this.checklist = res.retValue;

        this.checklist = res.retValue.map(item => {
          item.handleResultName = this.getHandleresult(item.handleResult);
          let stateArr = item.firstSpotCheckState.substr(1, item.firstSpotCheckState.length - 2).split(',');
          stateArr = stateArr.map(it => {
            return this.getSpotCheckState(it)
          })
          item.firstSpotCheckStateStr = stateArr.join(',')
          // 处理图片
          item.imageUrlAfter = []
          this.getPicUrl(item.imageUrl)
              .then(pic => {
                item.imageUrlAfter = pic
                this.picLoading = true
              })
          return item
        })
      });
    },
    // 获取图片
    getPicUrl(picList) {
      return new Promise((resolve) => {
        this.$store.dispatch('getPicture', {url: picList}).then((res_) => {
          resolve(res_)
        })
      })
    },
    getSpotCheckState(state) {
      switch (state) {
        case '8':
          return '收集不足';
          break
        case '9':
          return '态度欠佳';
          break
        case '10':
          return '录音缺失';
          break
        case '11':
          return '记录有误';
          break
        case '15':
          return '逻辑清晰';
          break
        case '16':
          return '收集完整';
          break
        case '17':
          return '态度良好';
          break
        case '18':
          return '记录准确';
          break

        case '21':
          return '混乱无序';
          break
        case '22':
          return '清楚流利';
          break
        case '23':
          return '生疏含混';
          break
        case '24':
          return '积极灵活';
          break
        case '25':
          return '刻板迟钝';
          break
      }
    },
    getHandleresult(state) {
      switch (state) {
        case 1:
          return '需重拨'
          break
        case 2:
          return '需注意'
          break
        case 3:
          return '平台相关'
          break
        case 4:
          return '需修改问卷'
          break
      }
    },
    /**
     * 获取患者上次的随访记录
     */
    getLastResult() {
      let vm = this;
      if (vm.$refs['lastFollowResult']) {
        vm.$refs['lastFollowResult'].asyncGetFollowResultByAdminNo({admitNo: this.patientData.admitNo})
      }
    },
    judgeStatus(status) {
      if (this.$route.query.abnormal == 5 || this.$route.query.abnormal == 6) {
        this.$router.go(-1)
        return
      } else {
        var messageObj = {
          9: '本患者已经标记为完成状态，获取下一个患者信息',
          10: '本患者已经标记为失访状态，获取下一个患者信息',
          11: '本患者已经标记为拒绝随访状态，获取下一个患者信息',
          12: '本患者已经标记为死亡状态，获取下一个患者信息',
          5: '本患者进入任务池，获取下一个患者信息',
        }
        this.$notify({
          title: '提示',
          message: messageObj[status],
          duration: 3000
        });
        this.$refs.userphone.followupModeChecked = false
        this.saveRemark();
      }
    },
    updateNextAbnormalPatient() {
      console.log("下一患者");
      let params = {
        userId: this.userid,
        followupTaskId: this.getTaskCenterId,
        pageIndex: this.$route.query.pageIndex,
        pageSize: 10
      };
      this.getAbnormalFollowupListAsync(params).then(res => {
        if (res.retValue.length > 0) {
          let nextPatieint = res.retValue.find(item => item.index == this.$route.query.index)
          console.log('nextPatieint=================>', nextPatieint);
          if (nextPatieint) {
            this.updatePage(3, nextPatieint)
          } else {
            this.updatePage(3, res.retValue[0])
          }
          // this.updatePage(3, res.retValue[0])
        } else {
          console.log("无患者");
          this.goBack();
        }
      });
    },
    updateNextAllAbPatient() {
      console.log("下一患者");
      let params = {
        userId: this.userid,
        followupTaskId: this.getTaskCenterId,
        pageIndex: this.$route.query.pageIndex,
        pageSize: 10,
        isAll: this.$route.query.isAll
      };
      this.asyncGetPatientInfoList(params).then(res => {
        if (res.retValue.length > 0) {
          this.resetPatient();
          let nextPatieint = res.retValue.find(item => item.index == this.$route.query.index * 1)
          if (nextPatieint) {
            this.updatePage(-1, nextPatieint)
          } else {
            this.updatePage(-1, res.retValue[0])
          }
        } else {
          console.log("无患者");
          this.goBack();
        }
      });
    },
    updateNextCallLaterPatient() {
      console.log("下一患者");
      let params = {
        userId: this.userid,
        followupTaskId: this.getTaskCenterId,
        pageIndex: this.$route.query.pageIndex,
        pageSize: 10
      };
      this.getCallLaterFollowupListAsync(params).then(res => {
        if (res.retValue.length > 0) {
          this.resetPatient();
          let nextPatieint = res.retValue.find(item => item.index == this.$route.query.index * 1)
          if (nextPatieint) {
            this.updatePage(4, nextPatieint)
          } else {
            this.updatePage(4, res.retValue[0])
          }
        } else {
          console.log("无患者");
          this.goBack();
        }
      });
    },
    goBack() {

    },
    // 是否是今日时间
    compareDate(gettime) {
      var year = new Date().getFullYear()
      var month = new Date().getMonth() + 1 < 10 ? `0${new Date().getMonth() + 1}` : new Date().getMonth() + 1
      var day = new Date().getDate() < 10 ? `0${new Date().getDate()}` : new Date().getDate()
      let today = `${year}-${month}-${day}`
      let date = gettime.split(' ')[0]
      if (today == date) {
        return true;
      } else {
        return false;
      }
    },
    // 是否复核
    isReviewChange() {
      this.updateFollowUpPatientInfoAsync()
    },
    // 获取患者标签
    getPatientTags(params){
      this.patientTags = params
    },
    refreshTags(){
      let vm = this;
      if (vm.$refs['userCard']) {
        vm.$refs['userCard'].getPatientTags()
      }
    },
    // ==================================async 请求====================================
    async getCallCenterMistakeJumpParams() {
      let questionId = await this.$store.dispatch('requestHandler',
          {
            fn: 'RestNewFollowupQuestionListServiceGetFollowupTaskQuestionnaireNewId',
            params: {
              followupTaskId: this.getTaskCenterId
            }
          }
      )
      let result = await this.$store.dispatch('requestHandler',{
        fn: 'RestMistakeCollectionControllerGetCallCenterMistakeJumpParams',
        params: {
          questionnaireId:questionId.retValue,
          followUpTaskId:this.getTaskCenterId,
          followUpPatientInfoId:this.$route.query.followUpPatientInfoId,
          seatId: sessionStorage.getItem('userid')
        }
      })
      return result
    },
    /**
     * 正常随访任务患者信息
     */
    async asyncGetNormalPatientInfo(params) {
      let vm = this;
      let pa = await this.getCallCenterMistakeJumpParams()
      console.log(pa);
      // let info = await this.$store.dispatch('requestHandler',{
      //   fn: 'RestNewFollowupCallCenterServiceGetFollowupTaskPatientInfo',
      //   params: {
      //     userId: params.userId,
      //     followupTaskId: vm.getTaskCenterId,
      //     followupPatientId: pa.followupPatientId,
      //   }
      // })
      let info = new RestNewFollowupCallCenterServiceGetFollowupTaskPatientInfo();
      info.p_userId = params.userId;
      info.p_followupTaskId = vm.getTaskCenterId || null;
      info.p_followupPatientId = pa.retValue.followupPatientId
      await info.send()
      if (info.result.status == 0) {
        return info.result
      } else if (info.result.status == -2) {
        vm.errorHandle(info.result);
        vm.getPatientError()
        return {}
      } else {
        vm.errorHandle(info.result);
        return {}
      }
    },
    /**
     * 获取今日随访完成的患者详情
     * @constructor
     */
    async asyncGetFollowUpTodayCompletePatientInfo(params) {
      let vm = this;
      let info = new RestNewFollowupCallCenterServiceGetFollowUpTodayCompletePatientInfo();
      info.p_followupState = params.followupState;
      info.p_followupTaskId = params.followupTaskId;
      info.p_followupPatientId = params.followupPatientId;
      await info.send()
      if (info.result.status == 0) {
        return info.result
      } else if (info.result.status == -2) {
        vm.errorHandle(info.result);
        vm.getPatientError()
        return {}
      } else {
        vm.errorHandle(info.result);
        return {}
      }
    },
    /**
     * 获取患者联系方式
     * @param patientId
     * @returns {Promise<void>}
     */
    async asyncGetPatientContacks(patientId) {
      let vm = this;
      let info = new RestNewFollowupCallCenterServiceGetFollowupPatientContactInformationList();
      info.p_patientId = patientId || 124684;
      info.p_followupTaskId = vm.getTaskCenterId
      await info.send()
      if (info.result.status == 0) {
        if (vm.$refs['userphone']) {
          vm.$refs['userphone'].getPatientList(info.result.retValue);
          // vm.manualCallBack(vm.$route.query.callNumber)
          //如果有最近拨打的患者才会调用

          vm.$refs.userphone.checkHasLastCallUser()
              .then(result => {
                // result: true代表没有拨打过
                if (result) {
                  this.hasFinsh = true
                } else {
                  this.hasFinsh = false
                }
              })
        }
      } else {
        vm.errorHandle(info.result);
      }
    },
    async getPatientContacksAsync() {
      let request = new RestNewFollowupCallCenterServiceGetFollowupPatientContactInformationList()
      request.p_patientId = this.$route.query.patientId || this.currentPatientId
      request.p_followupTaskId = this.getTaskCenterId
      await request.send()
      return request.result
    },
    /**
     * 获取随访患者的备注信息
     * @param patientId
     * @returns {Promise<void>}
     */
    async asyncGetPatientRemarks(patientId) {
      let vm = this;
      let info = new RestNewFollowupCallCenterServiceGetFollowupPatientRemarks();
      info.p_followupPatientId = patientId;
      await info.send()
      if (info.result.status == 0) {
        vm.form.remark = info.result.retValue;
      } else {
        vm.form.remark = ""
      }
    },
    /**
     * 更新随访患者的备注信息
     * @returns {Promise<void>}
     */
    async asyncUpdatePatientRemarks() {
      let vm = this;
      let info = new RestNewFollowupCallCenterServiceUpdateFollowupPatientRemarks();
      info.p_followupPatientId = vm.patientData.followupPatientId;
      info.p_followupRemarks = vm.form.remark;

      await info.send();
      vm.saveRemarkIng = false;
      if (info.result.status != 0) {
        vm.$message.error("备注更新失败,请及时联系相关技术（吴明份、吕明涛）")
      }

    },
    /**
     * 更新随访患者信息
     * @return {Promise<void>}
     */
    async asyncUpdatePatientFollowResult(params) {
      let vm = this;
      let info = new RestNewFollowupCallCenterServiceUpdateFollowupPatient();
      for (var keys in params) {
        info['p_' + keys] = params[keys]
      }
      await info.send()
      if (info.result.status == 0) {
        //TODO  更新当前患者的随访信息成功
        vm.judgeStatus(vm.follow.followStatus)
        this.confirmParams = {}
      } else {
        vm.$message.error("处理患者错误:" + info.result.desc)
      }
      vm.finishConfirm = false
    },
    /**
     * 点击异常患者
     * @return {Promise<void>}
     */
    async asyncUpdateAbnormalPatientFollow() {
      let vm = this;
      let info = new RestNewFollowupCallCenterServiceUpdateFollowupTaskAbnormalCall();
      info.p_userId = this.userid;
      info.p_followUpPatientInfoId = this.patientData.followUpPatientInfoId;
      info.p_taskId = this.getTaskCenterId
      info.p_followupPatientId = vm.patientData.followupPatientId
      await info.send()
      if (info.result.status == 0) {
        vm.judgeStatus(5)
        if (this.$route.query.abnormal == 5) {
          this.$router.go(-1)
        }
      } else {
        vm.$message.error("处理异常患者错误:" + info.result.desc)
      }
      vm.abnormalLoading = false
    },
    //历史抽查记录
    async getFollowupSpotCheckRemarksListAsync(p) {
      let request = new RestReferenceControllerGetFollowupSpotCheckRemarksList();
      request.p_followUpTaskId = p.followupTaskId || null;
      request.p_followUpPatientId = p.followUpPatientId || null;
      await request.send();
      return request.result;
    },
    // 异常随访
    async getAbnormalFollowupListAsync(p) {
      let request = new RestNewFollowupCallCenterServiceGetAbnormalFollowupTaskPatientInfoList();
      request.p_userId = p.userId;
      request.p_followupTaskId = p.followupTaskId;
      request.p_pageIndex = this.$route.query.pageIndex;
      request.p_pageSize = p.pageSize;
      await request.send();
      return request.result;
    },
    async asyncGetPatientInfoList(p) {
      let result = await this.$store.dispatch('requestHandler',{
        fn: 'RestNewFollowupCallCenterServiceGetAllFollowupTaskPatientInfoList',
        params: {
          userId: p.userId,
          followupTaskId: p.followupTaskId,
          admitNo: p.admitNo,
          patientName: p.patientName,
          followupStatus: p.followupStatus,
          pageIndex: this.$route.query.pageIndex,
          pageSize: 10,
        }
      })
      return result
    },
    // 稍后随访
    async getCallLaterFollowupListAsync(p) {
      let request = new RestNewFollowupCallCenterServiceGetCallLaterFollowupTaskPatientInfoList();
      request.p_userId = p.userId;
      request.p_followupTaskId = p.followupTaskId;
      request.p_pageIndex = this.$route.query.pageIndex;
      request.p_pageSize = p.pageSize;
      await request.send();
      return request.result;
    },
    // 更新随访任务异常呼叫或稍后拨打
    async updateAbnormalCallOrCallLaterAsync() {
      let vm = this
      let request = new RestNewFollowupCallCenterServiceUpdateAbnormalCallOrCallLater()
      request.p_userId = vm.userid,
          request.p_followUpPatientInfoId = vm.patientData.followUpPatientInfoId,
          request.p_laterCallTime = vm.afterCallForm.afterCallTime ? vm.afterCallForm.afterCallTime : null,
          request.p_patientId = vm.patientData.patientId,
          request.p_followupPatientId = vm.patientData.followupPatientId,
          request.p_followupTaskId = vm.getTaskCenterId
      await request.send()
      return request.result
    },
    // 质控开始时间 this.getTaskCenterId
    async addFollowupQualityTimeAsync(fpid) {
      let request = new RestFeedbackOutControllerAddFollowupQualityTime();
      request.p_followupPatientId = fpid;
      request.p_followUpTaskId = this.getTaskCenterId;
      request.p_spotCheckUserId = sessionStorage.getItem('userid');
      await request.send();
      return request.result;
    },
    // // 质控结束时间
    // async updateFollowupQualityTimeAsync() {
    //   let request = new RestFeedbackOutControllerUpdateFollowupQualityTime();
    //   request.p_id = this.followupQualityId;  //质控记录id
    //   console.log('质控结束');
    //   await request.send();
    //   return request.result;
    // },

    async updateFollowUpPatientInfoAsync() {
      let vm = this
      let request = new RestNewFollowupCallCenterServiceUpdateFollowUpPatientInfoByParams()
      request.p_followupPatientId = vm.patientData.followupPatientId
      request.p_followUpTaskId = vm.getTaskCenterId
      request.p_isReview = vm.isReview ? 1 : 0
      request.p_patientId = vm.patientData.patientId
      request.p_userId = sessionStorage.getItem('userid')
      request.p_userName = vm.username
      await request.send()
      return request.result
    },

  },
}
</script>
<style lang="scss">
.qs-content {
  height: calc(100% - 35px) !important
}

* {
  box-sizing: border-box;
}

.dethtime {
  .widget-container {
    width: 60%;
  }
}

.el-main {
  padding-top: 0 !important;
}

.no-data {
  p {
    margin: 40px 0 80px;
    font-size: 16px;
    color: rgba(0, 0, 0, 1);
  }

  display: table-cell;
  height: 60vh;
  vertical-align: middle;
  text-align: center;
  width: 480px;
  height: 100%;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.16), 0px 0px 2px 0px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  padding: 15px 15px 15px 20px;
  box-sizing: border-box;
  margin-top: 20px;
  margin-bottom: 20px;

}

.patient-page-container {
  padding-left: 443px;
  display: grid;
  grid-template-columns: 400px auto 30%;
  grid-gap: 25px 25px;
  //padding: 20px 20px 0 20px;
  height: calc(100vh - 135px);

  .patient-page-left {
    width: 440px;
    background-color: #fff;
    position: absolute;
    padding: 20px 20px 20px 20px;
    z-index: 8000;
    top: 70px;
    left: 0px;

    .tool-bar {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 15px;
    }

    .el-tabs__content {
      height: calc(100vh - 60px - 60px - 360px) !important;
      overflow: auto;
    }

    .checklist-container {
      font-size: 15px;
      border-bottom: 1px solid #ccc;
      padding: 10px 0;
      line-height: 30px;

      .checklist-item-header {
        display: flex;
        justify-content: space-between;
      }

      .item-header-date {
        color: #909399;
      }

      .checklist-item-detail {
        border: 1px solid #ccc;
        padding: 5px;
        border-radius: 4px;
        margin-bottom: 5px;

        p {
          word-break: break-all;
          word-wrap: break-word;
        }

        ul {
          padding: 0 1em;
          list-style-type: disc !important;
          list-style-position: inside !important;
        }

        ol {
          padding: 0 1em;
          list-style-type: decimal !important;
          list-style-position: inside !important;
        }

        em {
          font-style: oblique !important;
        }

        strong {
          font-weight: bold;
        }

        .ql-size-large {
          font-size: 1.5em;
        }

        .ql-size-small {
          font-size: 0.75em;
        }

        .ql-size-huge {
          font-size: 2.5em;
        }
      }

      .picture-show {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;

        .image-view {
          width: 100%;
        }

        .image-view > img {
          width: 40px;
          height: 40px;
          margin-right: 8px;
          text-align: center;
          cursor: pointer;
        }
      }
    }
  }

  .mask {
    z-index: 9999;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.05);
    position: absolute;
    top: 0;
    left: 0;
  }

  .patient-page-center {
    padding-top: 20px;
    width: 98%;
    margin-right: 20px;
    position: relative;

    .patient-page-center-mask {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      background-color: rgba(0, 0, 0, 0.1);
      z-index: 9999;
    }



    .title-panel {
      line-height: 28px;
      padding: 10px 10px;
      text-align: left;
      border-bottom: 1px solid #ccc;
    }

    .followup-status-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .follow-status-title {
      text-align: left;

    }

    .btn-wrapper {
      padding: 8px 10px;
      padding-top: 0px;
      width: 100%;
      display: flex;
      flex-direction: row-reverse;
      justify-content: space-between;
      align-items: center;
    }

    .follow-status-danger {
      width: 100%;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08), 0px 1px 4px 0px rgba(0, 0, 0, 0.16);
      border-radius: 8px;
      margin-top: 20px;

      .el-button {
        width: 100%;
        font-weight: 600;
        letter-spacing: 2px;
      }
    }

    .follow-status {
      .follow-status-top {
        position: relative;

        .mask {
          z-index: 99999;
          position: absolute;
          padding: auto;
          top: 69px;
          width: 100%;
          height: calc(100% - 69px);
          background-color: rgba(0, 0, 0, 0.05);
        }
      }

      .label-container {
        display: flex;
        align-items: center;
        padding: 10px 12px;
        padding-bottom: 8px;

        .title-panel-title {
          font-size: 14px;
          font-weight: 700;
          margin-right: 25px;
        }
      }

      .el-radio-group {
        display: flex;
        justify-content: space-around;

        .el-radio {
          min-width: 100px;
          text-align: left;
        }
      }


      .el-textarea {
        width: 380px;
      }

      .hasFinsh {
        .active {
          .el-radio-button__inner {
            font-weight: 600;
          }
        }
      }
    }
  }

  .patient-page-right {
    margin-top: 20px;
    width: 100%;
    border: 1px solid rgba(0, 0, 0, 0.04);
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08), 0px 1px 4px 0px rgba(0, 0, 0, 0.16);
    border-radius: 8px;
    transition: width .1s;
    //height: calc(100% - 60px) !important;
    .qs-header {
      display: flex;
      justify-content: space-between;
      height: 35px;
      align-items: center;
      background-color: #eee;
      padding: 10px;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
    }

    .stretch {
      font-size: 30px;
    }

    .qs-header-label {
      font-size: 20px;
      color: #000000;
      font-weight: 600;
    }
  }

  .stretchall {
    width: 75%;
    transition: width .3s;
  }

  .label-title {
    line-height: 28px;
    display: inline-block;
    color: #000;
    font-weight: 600;
    font-size: 16px;
  }

}

.patient-page {
  .abnormal-after-dialog {
    .fileId_selected {
      .el-radio {
        margin-right: 25px;
        margin-left: 0px !important;
        margin-bottom: 10px;

        .el-radio__input {
          display: none;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.remark-panel, .follow-status {
  position: relative;
  width: 100%;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08), 0px 1px 4px 0px rgba(0, 0, 0, 0.16);
  border-radius: 8px;
  margin-top: 15px;
  flex-direction: column;
  box-sizing: border-box;
  padding-bottom: 1px;
  position: relative;
}

.remark-panel {
  height: 410px;
  overflow: auto;
  position: relative;

  .remark-box {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 99;
  }
}
.patient-page {
  .abnormal-after-dialog {
    .content {
      display: flex;
      flex-direction: column;
      font-size: 16px;
      .el-form {
        min-height: 200px;
      }

      & > div {
        min-height: 30px;
      }
    }
  }
}
</style>
<style lang="scss">
#incapDialog {
  .el-dialog {
    border-radius: 10px;
    overflow: hidden;
    margin-top: 30vh !important;
  }
  .el-dialog__body {
    padding: 10px !important;
  }
  .el-dialog__header {
    padding: 10px;
    text-align: center;
    font-weight: 700;
    background-color: #f8f8f8;
    border-bottom: 1px solid #ccc;
    span {
      font-size: 16px;
    }
  }
}
</style>
